import React from "react";

import * as styles from "./styles";

export function Link({ url, onClick }: { url?: string; onClick?: () => void }) {
  if (!url) {
    return null;
  }

  return (
    <a
      onClick={onClick}
      data-testid="poi-popup-link"
      className={styles.container}
      href={url}
      target="_blank"
      rel="noopener noreferrer"
    >
      {url}
    </a>
  );
}
